import { Stack, Text, Button, ThemeIcon, Center, Alert } from '@mantine/core';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  inline?: boolean;
}

export function ErrorState({
  title = 'Something went wrong',
  message,
  onRetry,
  inline = false,
}: ErrorStateProps) {
  if (inline) {
    return (
      <Alert
        icon={<IconAlertCircle size={16} />}
        title={title}
        color="red"
        variant="light"
      >
        <Stack gap="sm">
          <Text size="sm">{message}</Text>
          {onRetry && (
            <Button
              variant="light"
              color="red"
              size="xs"
              leftSection={<IconRefresh size={14} />}
              onClick={onRetry}
            >
              Retry
            </Button>
          )}
        </Stack>
      </Alert>
    );
  }

  return (
    <Center py="xl">
      <Stack align="center" gap="md">
        <ThemeIcon variant="light" size={64} radius="xl" color="red">
          <IconAlertCircle size={32} />
        </ThemeIcon>

        <Text fw={500} size="lg">
          {title}
        </Text>

        <Text c="dimmed" size="sm" ta="center" maw={400}>
          {message}
        </Text>

        {onRetry && (
          <Button
            variant="light"
            color="red"
            leftSection={<IconRefresh size={16} />}
            onClick={onRetry}
          >
            Try again
          </Button>
        )}
      </Stack>
    </Center>
  );
}
